import { carsSlice } from '../store/slice';
import { carUploadSlice } from '../store/upload-slice';

export const {
  setAllCars,
  setCars,
  setModels,
  setCar,
  deleteCarFromStore,
  updateForm,
  resetCarForm,
} = carsSlice.actions;

export const { updateUploadFormValue, setDocDefinitions } = carUploadSlice.actions;
